/**
 * Les routes poussées du lot Contrôles : celles qu'il fait passer sur le design system.
 *
 * Pontée par le socle : `school-assessments` — « Mes contrôles », ouverte par le prochain contrôle de
 * l'accueil (`navigate("school-assessments")`, sans paramètre, comme le widget d'aujourd'hui). Elle
 * rend l'écran des ports pour un élève dont l'espace est allumé, hors espace parent et hors live, et
 * son écran legacy ailleurs (le tuteur, qui la pousse avec `{ studentId, student }`, garde le sien).
 *
 * L'écran n'est chargé qu'à son premier rendu (`loadedOnRender`).
 */
import { loadedOnRender } from "../loadedOnRender"
import { type StudentSpaceRouteTable } from "../studentSpaceRouteTypes"

export const assessmentsRoutes: StudentSpaceRouteTable<"assessments"> = {
    "school-assessments": loadedOnRender(
        // eslint-disable-next-line @typescript-eslint/no-require-imports
        () => require("./StudentAssessmentsScreen").StudentAssessmentsScreen,
        "StudentAssessmentsScreen"
    ),
}
